module.exports = __webpack_public_path__ + "img/numberEle.34df639c.svg";